import { HttpRequest } from './HttpRequest'

export const GetUnitListsByProjectId = async (projectId: string) => {
    try { 
        const response = await HttpRequest().get(`/unit/projectid/${projectId}`)
        if (response.data.message === 'OK') {
            const result: any[] = response.data.responseData
            return result
        }
        return []
    } catch (error: any) {
        throw new Error('ไม่สามารถโหลดข้อมูลยูนิตได้ กรุณาลองเข้าใหม่')
    }
}